import { createAction } from '@reduxjs/toolkit';
import { SmoLanguage } from '../../../../Models/Smo/SmoLanguage';
import { SmoMoon } from '../../../../Models/Smo/SmoMoon';
import { SmoMoonList } from '../../../../Models/Smo/SmoMoonList';

const resetState = createAction('CREATE_MOON_LIST_RESET_STATE');
const createFromMoonList = createAction<SmoMoonList>('CREATE_MOON_LIST_CREATE_FROM_MOON_LIST');
const setName = createAction<string>('CREATE_MOON_LIST_SET_NAME');
const setIsPublic = createAction<boolean>('CREATE_MOON_LIST_SET_IS_PUBLIC');
const setSearch = createAction<string>('CREATE_MOON_LIST_SET_SEARCH');
const setSearchResults = createAction<SmoMoon[]>('CREATE_MOON_LIST_SET_SEARCH_RESULTS');
const setSearchLanguage = createAction<SmoLanguage>('CREATE_MOON_LIST_SET_SEARCH_LANGUAGE');
const selectMoonWithId = createAction<string>('CREATE_MOON_LIST_SELECT_MOON_WITH_ID');
const addMoon = createAction<SmoMoon>('CREATE_MOON_LIST_ADD_MOON');
const removeMoonWithId = createAction<string>('CREATE_MOON_LIST_REMOVE_MOON_WITH_ID');
const moveMoon = createAction<{ atIndex: number; toIndex: number }>('CREATE_MOON_LIST_MOVE_MOON');
const createMoonList = createAction('CREATE_MOON_LIST_CREATE');

export default {
  resetState,
  createFromMoonList,
  setName,
  setIsPublic,
  setSearch,
  setSearchResults,
  setSearchLanguage,
  selectMoonWithId,
  addMoon,
  removeMoonWithId,
  moveMoon,
  createMoonList
};
